/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:55
 */
import Column from './Column';
import Slug from '../utils/Slug';

class SlugColumn extends Column {
  constructor(params) {
    super(params);
    this.init();
  }

  init() {
    let $elements = this.$root.find('.js-column-slug');
    for (let i = 0; i < $elements.length; i++) {
      new Slug({
        $element: $($elements[i]),
      });
    }
  }
}

export default SlugColumn;



// WEBPACK FOOTER //
// ./resources/assets/js/columns/SlugColumn.js